import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/Order/spread.png'
import _imports_1 from '../../assets/images/Order/spread1.png'


const _withScopeId = n => (_pushScopeId("data-v-6bdf41a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "second-routerView flex f-d" }
const _hoisted_2 = {
  key: 0,
  class: "manager-content"
}
const _hoisted_3 = { class: "order-serve flex j-s a-c" }
const _hoisted_4 = { class: "el-dropdown-link" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_8 = {
  key: 0,
  class: "orderList flex f-d"
}
const _hoisted_9 = { class: "toUse flex j-s-b" }
const _hoisted_10 = { class: "logo-title" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "serveSet flex a-c" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "serve-content flex j-s-b" }
const _hoisted_17 = { class: "content-left" }
const _hoisted_18 = {
  key: 0,
  class: "time"
}
const _hoisted_19 = { class: "money" }
const _hoisted_20 = { class: "content-right" }
const _hoisted_21 = { class: "actual-pay" }
const _hoisted_22 = {
  key: 0,
  class: "btn"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "评价", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "再次购买", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "btn"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "evaluate" }, "评价", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "orderList1 flex f-d"
}
const _hoisted_30 = { class: "toReceive flex j-s-b" }
const _hoisted_31 = { class: "logo-title" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "state" }
const _hoisted_34 = { class: "use-serve flex a-c" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "used-content flex j-s-b" }
const _hoisted_37 = { class: "content-left" }
const _hoisted_38 = { class: "time" }
const _hoisted_39 = { class: "content-right" }
const _hoisted_40 = ["onClick"]

import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import imgConstant from "../../config/img";
import { ref, reactive, onMounted, watch, computed } from "vue";
import UserTools from "@/services/session/UserTools";
import { OrderQuerySpec } from "@/services/datatype/business/order/OrderQuerySpec";
import { PageBlockAccessSpec } from "@/services/datatype/paging/PageBlockAccessSpec";
import { PageableData } from "@/services/datatype/paging/PageableData";
import { EnterpriseServiceOrder } from "@/services/datatype/business/order/EnterpriseServiceOrder";
import { OrderStatusName } from "@/services/datatype/business/order/OrderStatusName";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { DateFormat, FORMAT_TYPE } from "@/services/util/DateFormat";
import PageUtils from "@/utils/PageUtils";
import { OrderStatus } from "@/services/datatype/business/order/OrderStatus";
import { ElMessage } from "element-plus";
import Padding from "@/components/Layout/paging.vue";
import PerchUtil from "@/utils/Perch";
interface Order {
  name: string;
  logo: string;
  title: string;
  img: string;
  price: string;
  originlPrice: string | number;
  time: string;
  id: string | number;
  orderState: OrderStatus;
  creatTime: string;
  state: string | number;
}
interface OrderData {
  data: Order[];
}
interface serve {
  logo: string;
  title: string;
  name: string;
  state: number;
  img: string;
  time: string | number;
  id: string | number;
}
interface serveData {
  data: serve[];
}
interface _orderMenu {
  name: string;
  type: any[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderView',
  setup(__props) {

const $store = useStore();
// 路由

const router = useRouter();
const allState = ref<number>(1);
// 用户信息

// 面包屑
const data = reactive({
  data: [],
});

let userRole = UserTools.userRoles.roles[$store.state.currentRole.roleIndex];

// 订单数据
const orderList = reactive<OrderData>({ data: [] });
// 表头动态
const menuActive = ref<string>("0");
// 表头数据
const menuList = reactive<string[]>(
  userRole.userWorkPage ? ["购买的服务"] : ["购买的服务"]
);
const pageSize = ref<number>(3);
// 配额完成不详
const orderMenu: _orderMenu[] = [
  {
    name: "全部订单",
    type: [
      { title: "待支付", value: 1 },
      { title: "已完成", value: 3 },
      { title: "配额完结", value: 2 },
    ],
  },
  {
    name: "使用过的服务",
    type: [
      { title: "正在挑专家", value: 0 },
      { title: "被接受", value: 1 },
      { title: "已完成", value: 3 },
    ],
  },
];
const activeIndex = ref<number>(0);
const serviceList = reactive<serveData>({ data: [] });
const chooseOrderService = (val) => {
  if (activeIndex.value == 0) {
    data.data = orderList.data.filter((r) => {
      return r.state === val;
    });
    orderList.data = data.data;
  } else {
    data.data = serviceList.data.filter((r) => {
      return r.state === val;
    });
    serviceList.data = data.data;
  }
};
const toDetail = (item: Order): void => {
  if (item.orderState == 3) {
    router.push("/layout/order/" + item.id);
    $store.commit("bread/updateBread", {
      orderType: menuList[Number(menuActive.value)],
      orderState: orderMenu[activeIndex.value].name,
      orderId: "",
    });
    $store.commit("bread/updateDetailData", item);
  } else if (item.orderState == 1) {
    ElMessage.error("请先完成支付");
  }
};
const getOrderList = async (): Promise<void> => {
  if (userRole && userRole.enterpriseInfo) {
    orderList.data.splice(0, orderList.data.length);
    let orderQuerySpec = new OrderQuerySpec();
    let orderFilter = null; //new OrderFilter();
    orderQuerySpec.setFilter(orderFilter);
    let pageSpec = new PageBlockAccessSpec();
    pageSpec.pageSize = 3;
    pageSpec.maxPagesPerBatch = 100000000;
    orderQuerySpec.pageBlockSpec = pageSpec;
    let dataPromise: Promise<PageableData<EnterpriseServiceOrder>>;
    if (userRole.userWorkPage) {
      dataPromise = DefaultWebServiceFactory.getInstance()
        .getWebMineService()
        .findEnterpriseServiceOrders(UserTools.getUserId(), orderQuerySpec);
      await dataPromise.then((t: PageableData<EnterpriseServiceOrder>) => {
        getOrderListSync(t);
        data.data = orderList.data;
      });
    } else {
      dataPromise = DefaultWebServiceFactory.getInstance()
        .getWebEnterpriseHomeService()
        .findEnterpriseServiceOrdersByEnterpriseId(
          userRole.enterpriseInfo.entityId,
          orderQuerySpec
        );
      await dataPromise.then((t: PageableData<EnterpriseServiceOrder>) => {
        getOrderListSync(t);
        data.data = orderList.data;
      });
    }
  }
};
// 获取列表数据
const getOrderListSync = (t: PageableData<EnterpriseServiceOrder>): void => {
  orderList.data.splice(0, orderList.data.length);
  t.getPageData().forEach((r) => {
    if (!r.tradableImgUrls) {
      orderList.data.push({
        name: r.orderEnterpriseInfo.entityName,
        logo: r.orderEnterpriseInfo.logoImgUrl
          ? imgConstant + r.orderEnterpriseInfo.logoImgUrl
          : "https://img0.baidu.com/it/u=2260184878,3804521724&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
        title: r.title,
        img: r.serviceRequest.imageUrls[0].trim(),
        price: Math.floor(r.serviceRequest.trade.price) + ".00",
        originlPrice: r.serviceRequest.trade.originalPrice,
        time: r.serviceRequest.trade.startDay
          ? String(r.serviceRequest.trade.startDay).slice(0, 4) +
            "年" +
            String(r.serviceRequest.trade.startDay).slice(4, 6) +
            "月" +
            String(r.serviceRequest.trade.startDay).slice(6, 8) +
            "日"
          : "",
        id: r.serviceRequest.trade.tradeId,
        orderState: r.orderStatus,
        creatTime: DateFormat.dateFormatString(
          Number(r.createTime),
          FORMAT_TYPE.NORMAL3
        ),
        state: r.orderStatus,
      });
    } else {
      orderList.data.push({
        name: r.orderEnterpriseInfo.entityName,
        logo: r.orderEnterpriseInfo.logoImgUrl
          ? imgConstant + r.orderEnterpriseInfo.logoImgUrl
          : "https://img0.baidu.com/it/u=2260184878,3804521724&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
        title: r.title,
        img: r.tradableImgUrls[0].trim(),
        price: Math.floor(r.trade.price) + ".00",
        originlPrice: Math.floor(r.trade.originalPrice) + ".00",
        time: r.trade.startDay
          ? String(r.trade.startDay).slice(0, 4) +
            "年" +
            String(r.trade.startDay).slice(4, 6) +
            "月" +
            String(r.trade.startDay).slice(6, 8) +
            "日"
          : "",
        id: r.trade.tradeId,
        orderState: r.orderStatus,
        creatTime: DateFormat.dateFormatString(
          Number(r.createTime),
          FORMAT_TYPE.NORMAL3
        ),
        state: r.orderStatus,
      });
    }
  });
};
// 切换css 及 数组渲染
const chooseType = (i: number): void => {
  activeIndex.value = i;
  if (i == 0) {
    getOrderList();
  } else {
    getserviceList();
  }
};
const toTalk = (item) => {
  router.push({
    path: "/layout/talk",
    query: {
      rid: item.id,
      code: "false",
      breadType: "2",
    },
  });
};
const getserviceList = () => {
  serviceList.data.splice(0, serviceList.data.length);
  const code = [
    [15, 16, 18],
    [0, 1, 3],
  ];
  code[0].forEach((value: number) => {
    code[1].forEach((v) => {
      DefaultWebServiceFactory.getInstance()
        .getWebEnterpriseServiceRequestService()
        .findEnterpriseServiceRequestsByClientEntity(
          userRole.enterpriseInfo.entityId,
          value,
          v,
          PageUtils.getNewPageBlockAccessSpec(3, 100000000)
        )
        .then((t) => {
          // console.log(t.getPageData());
          [...t.getPageData()].forEach((r) => {
            serviceList.data.push({
              logo: r.orderingEnterpriseInfo.logoImgUrl
                ? imgConstant + r.orderingEnterpriseInfo.logoImgUrl
                : "https://img0.baidu.com/it/u=2260184878,3804521724&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
              name: r.orderingEnterpriseInfo.entityName,
              title: r.tradeTitle,
              id: r.rid,
              img: imgConstant + r.imageUrls[0].trim(),
              time: r.createTime,
              state: v,
            });
          });
        });
    });
  });
  data.data = serviceList.data;
};
const getData: (x: any[]) => void = (x: any[]): void => {
  data.data = x;
  PerchUtil.Perch(
    pageSize.value,
    data.data.length,
    ".order",
    activeIndex.value == 0 ? ".orderList" : ".orderList1"
  );
};
const roleIndex = computed(() => {
  //返回的是ref对象
  return $store.state.currentRole.roleIndex;
});
watch(roleIndex, (newVal) => {
  userRole = UserTools.userRoles.roles[newVal];
  console.log(UserTools.isLawyer());
  !UserTools.isLawyer() && (getOrderList(), getserviceList());
});
onMounted(() => {
  getOrderList();
  // getserviceList()
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (allState.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_menu, {
            class: "el-menu-demo",
            mode: "horizontal",
            "background-color": "transparent",
            "default-active": menuActive.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: index,
                  index: String(index),
                  onClick: ($event: any) => (menuActive.value = String(index))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1032, ["index", "onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["default-active"]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderMenu, (item, index) => {
              return _createElementVNode("div", { key: index }, [
                _createVNode(_component_el_dropdown, { trigger: "click" }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderMenu[index].type, (item, index1) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: index1,
                            onClick: ($event: any) => (chooseOrderService(item.value))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (chooseType(index)),
                        class: _normalizeClass(["chooseBox flex j-c a-c", activeIndex.value === index ? 'active' : ''])
                      }, [
                        _createTextVNode(_toDisplayString(item.name) + " ", 1),
                        (activeIndex.value == index)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                          : (_openBlock(), _createElementBlock("img", _hoisted_7))
                      ], 10, _hoisted_5)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ])
            }), 64))
          ]),
          (activeIndex.value == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "order",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: item.logo,
                          alt: ""
                        }, null, 8, _hoisted_11),
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      (item.orderState)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "state1",
                            onClick: ($event: any) => (toDetail(item))
                          }, _toDisplayString(_unref(OrderStatusName).getDisplayName(item.orderState)), 9, _hoisted_12))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "state2",
                            onClick: ($event: any) => (toDetail(item))
                          }, " 去使用> ", 8, _hoisted_13))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: _unref(imgConstant) + item.img,
                        alt: ""
                      }, null, 8, _hoisted_15),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                          (item.time)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, " 有效期至 " + _toDisplayString(item.time), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_19, "￥" + _toDisplayString(item.originlPrice), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("h3", _hoisted_21, "实付款￥" + _toDisplayString(item.price), 1),
                          (item.orderState == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.data, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "order",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("img", {
                          src: item.logo,
                          alt: ""
                        }, null, 8, _hoisted_32),
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(orderMenu[activeIndex.value].type.find((r) => r.value == item.state)
                  .title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("img", {
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_35),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("h3", null, _toDisplayString(item.title) + _toDisplayString(item.id), 1),
                          _createElementVNode("p", _hoisted_38, " 发起时间：" + _toDisplayString(_unref(DateFormat).dateFormatString(
                      Number(item.time),
                      _unref(FORMAT_TYPE).NORMAL3
                    )), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("button", {
                            class: "watch",
                            onClick: ($event: any) => (toTalk(item))
                          }, "去查看", 8, _hoisted_40)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true),
    _createVNode(Padding, {
      data: activeIndex.value == 1 ? serviceList.data : orderList.data,
      "page-size": 3,
      onGetData: getData
    }, null, 8, ["data"])
  ]))
}
}

})